import {takeLatest} from 'redux-saga/effects';

import {getPageEditors} from './get/saga';
import {getPageEditorsSaga} from './getUsers/saga';
import {getPageEditorsACS, getUsersACS} from './requestAC';

export function* pageEditorsSaga() {
  yield takeLatest(getPageEditorsACS.type, getPageEditors);
  yield takeLatest(getUsersACS.type, getPageEditorsSaga);
}
